import { Search } from "lucide-react";
import { BrandLogo } from "../BrandLogo";
import { useShellTabs } from "../../stores/shell-tabs";
import { NotificationBell } from "./NotificationBell";
import { UserMenu } from "./UserMenu";

interface AppHeaderProps {
  onOpenCommandPalette: () => void;
}

export function AppHeader({ onOpenCommandPalette }: AppHeaderProps) {
  const activeTab = useShellTabs((s) => s.activeTab());

  return (
    <header
      className="flex w-full shrink-0 items-center gap-3 border-b border-line bg-surface px-3 sm:px-4"
      style={{ height: "var(--header-height)" }}
    >
      <div className="flex min-w-0 items-center gap-2.5">
        <BrandLogo className="h-8 w-auto max-w-[120px] shrink-0 object-contain object-left" />
        <span className="hidden shrink-0 text-sm font-light text-muted-2 md:inline" aria-hidden="true">
          |
        </span>
        <span className="hidden min-w-0 truncate text-sm font-medium text-muted md:inline">
          {activeTab?.title ?? "Workspace"}
        </span>
      </div>

      <div className="mx-auto w-full max-w-xl flex-1">
        <button
          type="button"
          onClick={onOpenCommandPalette}
          className="flex w-full items-center gap-2 rounded-xl border border-line bg-input-bg px-3 py-2 text-left text-sm text-muted transition-colors hover:border-brand-pink/30 hover:bg-hover"
        >
          <Search size={16} className="shrink-0" />
          <span className="flex-1 truncate">Search pages, actions, settings…</span>
          <kbd className="hidden rounded-md border border-line bg-input-bg px-1.5 py-0.5 text-[10px] font-medium text-muted sm:inline">
            Ctrl K
          </kbd>
        </button>
      </div>

      <div className="flex shrink-0 items-center gap-1">
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}
